var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { Service } from '~/core/service';
var OutsourceService = /** @class */ (function (_super) {
    __extends(OutsourceService, _super);
    function OutsourceService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 新增/修改委外方管理
     */
    OutsourceService.prototype.createOutsource = function (data) {
        return this.netService.send({
            server: domainService.outsourceController.createOutsource,
            data: data
        });
    };
    /**
     * 删除委外方
     */
    OutsourceService.prototype.deleteOutsource = function (id) {
        return this.netService.send({
            server: domainService.outsourceController.deleteOutsource,
            data: {
                id: id
            }
        });
    };
    /**
     * 统计委托方信息的 案件信息
     */
    OutsourceService.prototype.getAllOutSourceInfoByCase = function (data, page) {
        return this.netService.send({
            server: domainService.outsourceController.getAllOutSourceInfoByCase,
            data: data,
            page: page
        });
    };
    /**
     * 查询委外方
     */
    OutsourceService.prototype.query = function (data, page) {
        return this.netService.send({
            server: domainService.outsourceController.query,
            data: data,
            page: page
        });
    };
    /**
     * 获取所有的委外方(包含委外方id,委外方名称)
     */
    OutsourceService.prototype.getOutSourceList = function () {
        return this.netService.send({
            server: domainService.outsourceController.getOutsourceList,
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceService.prototype, "netService", void 0);
    return OutsourceService;
}(Service));
export { OutsourceService };
